// Helper utilities for normalizing course visibility across roles.

/**
 * Convert an array of Course documents into the same shape returned by the
 * enrollment API. This makes it easier to reuse UI code that expects
 * enrollment objects without duplicating components per role.
 *
 * @param {Array<Object>} courses
 * @returns {Array<Object>} enrollment-like entries
 */
export function mapCoursesToEnrollments(courses = []) {
  return courses
    .map((course) => {
      if (!course) return null;
      const courseId = course._id || course.id || course.code;
      if (!courseId) return null;
      return {
        id: `catalog-${courseId}`,
        status: course.status || 'active',
        progress: 0,
        assignedAt: null,
        course: {
          id: courseId,
          grade: course.grade,
          subject: course.subject,
          code: course.code,
          title: course.title,
        },
      };
    })
    .filter(Boolean);
}
